// @ts-nocheck
/* eslint-enable */
export const useDynamicBlurb = ({ areaType, areaName, numberOfListings, houseOrApartment } = {}) => {
  const hotOrNot = numberOfListings > 50 ? 'hot ' : '';
  const hotOrNotNeighborhood = numberOfListings > 50 ? 'most popular neighborhoods and hotspots' : 'neighborhoods';
  const schoolBlurb = `Browse through ${numberOfListings} ${houseOrApartment} rentals near ${areaName}. In ${hotOrNot}markets near ${areaName}, it’s important to move fast and contact the newest listings ASAP.`;
  const DYNAMIC_SENTENCE = {
    city: `Browse through ${numberOfListings} ${houseOrApartment} rentals throughout ${areaName}’s ${hotOrNotNeighborhood}. In ${hotOrNot}markets like ${areaName}, it’s important to move fast and contact the newest listings ASAP.`,
    neighborhood: `Browse through ${numberOfListings} ${houseOrApartment} rentals throughout ${areaName}. In ${hotOrNot}markets like ${areaName}, it’s important to move fast and contact the newest listings ASAP.`,
    zip: `Browse through ${numberOfListings} ${houseOrApartment} rentals throughout the ${areaName} area. In ${hotOrNot}markets like the ${areaName} area, it’s important to move fast and contact the newest listings ASAP.`,
    county: `Browse through ${numberOfListings} ${houseOrApartment} rentals throughout the ${areaName} area. In ${hotOrNot}markets like ${areaName}, it’s important to move fast and contact the newest listings ASAP.`,
    highschool: schoolBlurb,
    middleschool: schoolBlurb,
    primaryschool: schoolBlurb,
    university: schoolBlurb,
  };
  const dynamicBlurb = DYNAMIC_SENTENCE[areaType];

  return [dynamicBlurb];
};
